import React from 'react';
import { cn } from '@/lib/utils';

export interface NumericProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

// Wrap any live-data number (score, rating, count, position, duration, %)
// so font + alignment stay consistent and don't depend on every dev remembering
// the design-system rule.
export const Numeric = React.forwardRef<HTMLSpanElement, NumericProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <span ref={ref} className={cn('font-mono tabular-nums', className)} {...props}>
        {children}
      </span>
    );
  },
);
Numeric.displayName = 'Numeric';
